import React from 'react';
import { SvgIcon } from '../../utils';
import OfficeIconPath from '../../assets/img/icons/icon--office-building.svg';

export const MODAL_WIDTH = 360;
export const OFFICE_ICON = <SvgIcon path={OfficeIconPath} color="#7DFF8A" />;
